export interface EmpresaPlataforma {
  id: string;
  razao_social: string;
  nome_fantasia: string;
  cnpj: string;
  email: string;
  telefone: string;
  status: 'ativa' | 'pendente' | 'suspensa' | 'inativa';
  data_cadastro: string;
  plano: 'basico' | 'profissional' | 'enterprise';
  participantes_ativos: number;
  participantes_total: number;
  participantes_em_analise: number;
  saldo_conta_digital: number;
  pontos_disponiveis: number;
  faturamento_mensal: number;
  responsavel_nome: string;
  responsavel_email: string;
  responsavel_cargo: string;
  endereco: string;
  cidade: string;
  estado: string;
  cep: string;
  segmento: string;
  ultimo_acesso?: string;
}

export const empresasPlataforma: EmpresaPlataforma[] = [
  {
    id: 'EMP-001',
    razao_social: 'GetPoints Tecnologia S.A.',
    nome_fantasia: 'getPoints',
    cnpj: '12.345.678/0001-90',
    email: 'contato@getpoints.com.br',
    telefone: '(11) 98765-4321',
    status: 'ativa',
    data_cadastro: '2025-08-15',
    plano: 'enterprise',
    participantes_ativos: 1247,
    participantes_total: 1500,
    participantes_em_analise: 52,
    saldo_conta_digital: 84500.5,
    pontos_disponiveis: 250000,
    faturamento_mensal: 12800.0,
    responsavel_nome: 'André Costa',
    responsavel_email: 'andre@getpoints.com.br',
    responsavel_cargo: 'CEO',
    endereco: 'Av. Paulista, 1000',
    cidade: 'São Paulo',
    estado: 'SP',
    cep: '01310-100',
    segmento: 'Tecnologia',
    ultimo_acesso: '2026-05-08T10:30:00Z'
  },
  {
    id: 'EMP-002',
    razao_social: 'Inovação Digital S.A.',
    nome_fantasia: 'Inova Digital',
    cnpj: '98.765.432/0001-10',
    email: 'contato@inovacaodigital.com.br',
    telefone: '(21) 99876-5432',
    status: 'ativa',
    data_cadastro: '2025-10-20',
    plano: 'profissional',
    participantes_ativos: 456,
    participantes_total: 500,
    participantes_em_analise: 18,
    saldo_conta_digital: 32100.75,
    pontos_disponiveis: 85000,
    faturamento_mensal: 5200.0,
    responsavel_nome: 'Ricardo Ferreira',
    responsavel_email: 'ricardo@inovacaodigital.com.br',
    responsavel_cargo: 'Diretor de Vendas',
    endereco: 'Rua do Rio, 500',
    cidade: 'Rio de Janeiro',
    estado: 'RJ',
    cep: '20040-010',
    segmento: 'Consultoria',
    ultimo_acesso: '2026-05-07T16:45:00Z'
  },
  {
    id: 'EMP-003',
    razao_social: 'Consultoria Tech Brasil Ltda.',
    nome_fantasia: 'TechBrasil',
    cnpj: '45.678.901/0001-23',
    email: 'contato@techbrasil.com.br',
    telefone: '(31) 98765-1234',
    status: 'ativa',
    data_cadastro: '2025-11-05',
    plano: 'profissional',
    participantes_ativos: 234,
    participantes_total: 300,
    participantes_em_analise: 24,
    saldo_conta_digital: 18900.0,
    pontos_disponiveis: 45000,
    faturamento_mensal: 3200.0,
    responsavel_nome: 'Fernanda Costa',
    responsavel_email: 'fernanda@techbrasil.com.br',
    responsavel_cargo: 'Gerente de RH',
    endereco: 'Av. Amazonas, 2000',
    cidade: 'Belo Horizonte',
    estado: 'MG',
    cep: '30180-001',
    segmento: 'Consultoria de TI',
    ultimo_acesso: '2026-05-08T08:15:00Z'
  },
  {
    id: 'EMP-004',
    razao_social: 'Sistemas Integrados Ltda.',
    nome_fantasia: 'SysInt',
    cnpj: '23.456.789/0001-45',
    email: 'contato@sistemasintegrados.com.br',
    telefone: '(41) 99876-9876',
    status: 'ativa',
    data_cadastro: '2025-12-01',
    plano: 'basico',
    participantes_ativos: 89,
    participantes_total: 120,
    participantes_em_analise: 9,
    saldo_conta_digital: 5400.25,
    pontos_disponiveis: 15000,
    faturamento_mensal: 1200.0,
    responsavel_nome: 'Paulo Henrique',
    responsavel_email: 'paulo@sistemasintegrados.com.br',
    responsavel_cargo: 'Proprietário',
    endereco: 'Rua XV de Novembro, 300',
    cidade: 'Curitiba',
    estado: 'PR',
    cep: '80020-310',
    segmento: 'Software',
    ultimo_acesso: '2026-05-06T14:00:00Z'
  },
  {
    id: 'EMP-005',
    razao_social: 'Distribuidora Expresso LTDA',
    nome_fantasia: 'Expresso Distribuidora',
    cnpj: '67.890.123/0001-67',
    email: 'contato@expressodist.com.br',
    telefone: '(11) 91234-5678',
    status: 'pendente',
    data_cadastro: '2026-05-01',
    plano: 'profissional',
    participantes_ativos: 0,
    participantes_total: 0,
    participantes_em_analise: 0,
    saldo_conta_digital: 0,
    pontos_disponiveis: 0,
    faturamento_mensal: 0,
    responsavel_nome: 'Carlos Eduardo',
    responsavel_email: 'carlos@expressodist.com.br',
    responsavel_cargo: 'Diretor',
    endereco: 'Av. do Estado, 1500',
    cidade: 'São Paulo',
    estado: 'SP',
    cep: '01140-001',
    segmento: 'Logística',
    ultimo_acesso: undefined
  },
  {
    id: 'EMP-006',
    razao_social: 'Clínica Saúde Total S.A.',
    nome_fantasia: 'Saúde Total',
    cnpj: '34.567.890/0001-12',
    email: 'admin@saudetotal.com.br',
    telefone: '(51) 98765-4321',
    status: 'suspensa',
    data_cadastro: '2025-09-10',
    plano: 'basico',
    participantes_ativos: 45,
    participantes_total: 200,
    participantes_em_analise: 15,
    saldo_conta_digital: 1200.0,
    pontos_disponiveis: 5000,
    faturamento_mensal: 800.0,
    responsavel_nome: 'Dra. Amanda Ribeiro',
    responsavel_email: 'amanda@saudetotal.com.br',
    responsavel_cargo: 'Administradora',
    endereco: 'Rua dos Médicos, 100',
    cidade: 'Porto Alegre',
    estado: 'RS',
    cep: '90020-080',
    segmento: 'Saúde',
    ultimo_acesso: '2026-04-15T09:00:00Z'
  },
  {
    id: 'EMP-007',
    razao_social: 'Educação Premium Ltda.',
    nome_fantasia: 'Educa Premium',
    cnpj: '78.901.234/0001-56',
    email: 'contato@educapremium.com.br',
    telefone: '(19) 99876-5432',
    status: 'inativa',
    data_cadastro: '2025-07-20',
    plano: 'basico',
    participantes_ativos: 0,
    participantes_total: 80,
    participantes_em_analise: 0,
    saldo_conta_digital: 0,
    pontos_disponiveis: 0,
    faturamento_mensal: 0,
    responsavel_nome: 'Mariana Silva',
    responsavel_email: 'mariana@educapremium.com.br',
    responsavel_cargo: 'Diretora',
    endereco: 'Av. dos Estudantes, 250',
    cidade: 'Campinas',
    estado: 'SP',
    cep: '13013-080',
    segmento: 'Educação',
    ultimo_acesso: '2026-02-10T11:00:00Z'
  }
];